import styled from 'styled-components';
import { MenuItemMixin } from '../../mixins/components/MenuItemMixin';
export var StyledMenuItem = /*#__PURE__*/styled.button.withConfig({
  displayName: "StyledMenuItem",
  componentId: "c11n-8-111-1__sc-1flhz79-0"
})(["", ""], MenuItemMixin);